export enum RegisterResponseType {
  Success = 'Success',
  EMailAlreadyInUse = 'EMailAlreadyInUse'
}
